import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from './Header'
import Footer from './Footer'
import { SearchWrapper } from '../search'

// Additional styles
import '../../../styles/app.css'
import '../../../styles/prism.css'

import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import useDarkMode from 'use-dark-mode'

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'druk-wide';
    font-style: normal;
    font-weight: normal;
  }
  body {
    font-family: 'druk-wide';
  }
`

const theme = {
    fg: `black`,
    bg: `white`,
}

const darkModeTheme = ({ fg, bg }) => {
    return {
        fg: bg,
        bg: fg,
    }
}

const App = styled.div`
  background: ${props => props.theme.bg};
  color: ${props => props.theme.fg};
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-rows: max-content auto max-content;
`

export const DarkModeContext = React.createContext(null)

function DefaultLayout({ children, bodyClass, mainClass, header, headerDividerStyle }) {
    const darkMode = useDarkMode(false)

    return (
        <ThemeProvider theme={darkMode.value ? darkModeTheme(theme) : theme}>
            <DarkModeContext.Provider value={darkMode.value}>
                <App>
                    {/*<GlobalStyle />*/}
                    <Helmet>
                        <html lang="en" className="fs-base" />
                        <link type="text/css" href="https://docs.ghost.org/fonts/693317/DB286F3BA61F1A1F0.css" rel="stylesheet" />
                        <body className={`${bodyClass} flex flex-column whitney f7 fw4 darkgrey readability`} />
                    </Helmet>

                    <SearchWrapper>
                        {header || <Header dividerStyle={headerDividerStyle} />}

                        <main className={mainClass || `bg-whitegrey-l2 pb5 pb10-ns`}>
                            {children}
                        </main>

                        <Footer />
                    </SearchWrapper>
                </App>
            </DarkModeContext.Provider>
        </ThemeProvider>
    )

    // return (
    //     <>
    //         <Helmet>
    //             <html lang="en" className="fs-base" />
    //             <link type="text/css" href="https://docs.ghost.org/fonts/693317/DB286F3BA61F1A1F0.css" rel="stylesheet" />
    //             <body className={`${bodyClass} flex flex-column whitney f7 fw4 darkgrey readability`} />
    //         </Helmet>
    //
    //         <SearchWrapper>
    //             {header || <Header dividerStyle={headerDividerStyle} />}
    //
    //             <main className={mainClass || `bg-whitegrey-l2 pb5 pb10-ns`}>
    //                 {children}
    //             </main>
    //
    //             <Footer />
    //         </SearchWrapper>
    //     </>
    // )
}

// const DefaultLayout = ({ children, bodyClass, mainClass, header, headerDividerStyle }) => (
//         <>
//             <Helmet>
//                 <html lang="en" className="fs-base" />
//                 <link type="text/css" href="https://docs.ghost.org/fonts/693317/DB286F3BA61F1A1F0.css" rel="stylesheet" />
//                 <body className={`${bodyClass} flex flex-column whitney f7 fw4 darkgrey readability`} />
//             </Helmet>
//
//             <SearchWrapper>
//                 {header || <Header dividerStyle={headerDividerStyle} />}
//
//                 <main className={mainClass || `bg-whitegrey-l2 pb5 pb10-ns`}>
//                     {children}
//                 </main>
//
//                 <Footer />
//             </SearchWrapper>
//         </>
//
// )

DefaultLayout.defaultProps = {
    headerDividerStyle: `shadow`,
    bodyClass: `bg-white`,
}

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    bodyClass: PropTypes.string,
    mainClass: PropTypes.string,
    header: PropTypes.element,
    headerDividerStyle: PropTypes.oneOf([`hairline`, `shadow`]),
}

export default DefaultLayout
